import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { db } from "../../firebase";
import {equalTo, onValue, ref, set, query, orderByChild, orderByValue, get } from 'firebase/database';

import AddNewButton from "../Buttons/AddNewButton";
import StatusCard from "../Cards/StatusCard";




export default CollectorStatus => {
    const [numBinsCount, setNumBinsDataCount] = useState({
        collectorsActive: 0, 
        collectorsTotal:0,
    
    });

    // const data = Data;

    
    const getCollectors = async () =>{
        const colRef = await ref(db, 'workers');
        onValue(colRef, (snapshot) => {
            const data = snapshot.val();
            // var activeBins = Object.keys(data).length
            var activeCols = Object.values(data).filter(worker => worker.status === 'active').length;
            var totalCols = Object.values(data).length;
            setNumBinsDataCount({
                collectorsActive: activeCols,
                collectorsTotal: totalCols,
                
            });
            // console.log(activeBins)
            // const filledBins = query(data, orderByChild('status'))
            console.log(totalCols)
        })

    }
    
    useEffect(()=>{
        getCollectors()
    },[])

    return (
        <div className="max-w-screen-xl px-4 mx-auto">
            <div className="flex items-center justify-between mb-4 binhead">
                <h3 className="mb-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-white">Collectors Status</h3>
                <div className="">
                    <Link to={'/addcollector'}><AddNewButton innerTxt={"+ Add New Collector"}/></Link>
                </div>
            </div>
            {/* "https://drive.google.com/uc?export=view&id=1P5EFS9UJLXe1O-0rA1zvH0TpxyvtXrXC" */}
            
            <div className="flex gap-x-3 ">
                <StatusCard cardWidth={"w-1/3"} color="text-white" cardhead="Total Collectors" CardVal={numBinsCount.collectorsTotal} closeToFillShow={false} imgShow={true} imgImage={"https://drive.google.com/uc?export=view&id=1cRNzpCTp9-WbO3vd5G4fK_EYlTYJpgHL"}/>
                <StatusCard cardWidth={"w-1/3"} color="text-green-500" cardhead="Active Collectors" CardVal={numBinsCount.collectorsActive} closeToFillShow={false} imgShow={true} imgImage={"https://drive.google.com/uc?export=view&id=1P5EFS9UJLXe1O-0rA1zvH0TpxyvtXrXC"}/>
                {/* <StatusCard cardWidth={"w-1/3"} color="text-red-500" cardhead="Broken Bins" CardVal={3} closeToFillShow={false} imgShow={true} imgImage={"https://pngimg.com/d/recycle_bin_PNG45.png"}/> */}
            </div>
        </div>
    )
} 